<!-- Start: Simple Header with Logo -->
<header class="simple" *ngIf="!userLoggedIn">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <ng-container *ngIf="brandingService.logoUrl$ | async as logoUrl; else defaultLogo">
          <img class="il-logo" [src]="logoUrl" (error)="onLogoError()" alt="PatientGo">
        </ng-container>
        <ng-template #defaultLogo>
          <img class="il-logo"
               [class.il-logo--placeholder]="(brandingService.logoUrl$ | async) === undefined"
               src="/assets/img/illingworth-logo.svg"
               alt="PatientGo">
        </ng-template>
      </div>
    </div>
  </div>
</header>
<!-- End: Simple Header with Logo -->
